<div class="row">
  @if (quotes?.current?.description) {
    <div class="column six md-four">
      <ds-premium-detail [quote]="quotes?.current"></ds-premium-detail>
    </div>
  }
  @if (quotes?.new?.description) {
    <div class="column six md-four">
      <ds-premium-detail [quote]="quotes?.new"></ds-premium-detail>
    </div>
  }
</div>
<div class="row pad-top-20 text-center">
  @if (quotes) {
    <div class="column twelve md-eight">
      Quote expires <b>{{ quoteExpirationDate }}</b>
    </div>
  }
</div>
